import React, { useEffect, useState, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import "./Layout.css";
import LanguageSwitcher from "../../LanguageSwitcher";
import { ThemeSwitcher, useTheme } from "../../ThemeSwitcher/ThemeSwitcher";
import logo from "../../../assets/images/scrollwhitelogo.svg";
import ScrollWhiteLogo from "../../../assets/images/scrollwhitelogo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RxHamburgerMenu, RxCross2 } from "react-icons/rx";
import { GiHamburgerMenu } from "react-icons/gi";
import Sidebar from "./Sidebar";
import { GoSun } from "react-icons/go";
import { encryptUserId, decryptUserId } from "../../../utils/cryptoUtils";
import { applyTheme } from "../../../utils/theme";
import {
  getLocalStorageItem,
  logAuditEntry,
  removeLocalStorageItem,
  isValidUrl,
} from "../../../utils/HelperFunctions";
import { useMsal } from "@azure/msal-react";
import { azureLogout } from "../Auth/authHelpers";
import "./EnviHeader.css";
import { CgProfile } from "react-icons/cg";
import { useUserGroups } from "../Auth/UserGroupsContext";
import { Modal, Button } from "react-bootstrap";
import SignInModal from "../Auth/signIn-popup";
import ChangePasswordPage from "../Auth/ChangePassword";
import MyInfoModal from "../Auth/myinfo-popup";
import SearchComponent from "../../../modules/enviroportal/components/Search/Search";
import { FiMenu } from "react-icons/fi";
import { showAlert } from "../../../utils/Helpers";
import { BsMoonStars } from "react-icons/bs";
import i18n from "../../../i18n";
import { useEDPContext, useHeaderProfileContext } from "../../EDPContext";
import { checkIfUserExistsInArcGISPortal, redirectToIDP } from "../Auth/authHelpers";
import { useDirection } from "../../DirectionContext";


const Sitemap = lazy(() =>
  import("../../../modules/enviroportal/components/Sitemap/Sitemap")
);
const RelatedLinks = lazy(() =>
  import("../../../modules/enviroportal/components/RelatedLinks/RelatedLinks")
);
const Feedback = lazy(() =>
  import("../../../modules/enviroportal/components/Feedback/Feedback")
);

const About = lazy(() => import("../../About"));
// let isAuthenticated = false;
let elementInstances = {}
const Header = ({ source, mapview, isMarineSearchHidden }) => {
  const isMainPage = source === "home";
  const [show, setShow] = useState(false);
  const [infoshow, setInfoShow] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // React Router hook to get URL params
  let { theme, toggleTheme } = useTheme();
  const nativeTheme = searchParams.get("theme") || theme;
  theme = localStorage.getItem("webView") === "true" ? nativeTheme : localStorage.getItem("theme") || theme
  const { t, i18n } = useTranslation();

  const { instance, accounts } = useMsal();
  const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
  const { resetUserGroups } = useUserGroups();
  const [sidebar, setSidebar] = useState(false);
  const [loading, setLoading] = useState(false); // State to manage the loading state
  const { globalDataContextValue, NativeAppContextValue } = useEDPContext();
  const { globalData, setGlobalData } = globalDataContextValue;
  const { nativeAppAPIState, setNativeAppAPIState } = NativeAppContextValue;
  var userCredentialsContextValues = globalData.find(module => module.moduleName === "Header")?.data;
  // State to track whether the sidebar is visible or not
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [rightMenuSelectedItem, setRightMenuSelectedItem] = useState(null);
  const [showResetConfirmation, setShowResetConfirmation] = useState(false);
  const [ShowchangePassword, setShowchangePassword] = useState(false);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [isChecked, setIsChecked] = useState(theme === "dark");
  //const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { navClass, isHeaderProfileDropdownOpen, setIsHeaderProfileDropdownOpen } = useHeaderProfileContext();
  const { isWebView, setIsWebView } = useEDPContext();

  let URLJWTtoken = searchParams.get("token"); // Extract 'token' from the URL
  const adToken = searchParams.get("adtoken");
  const userAgent = navigator.userAgent || "";
  const nativeApp = userAgent.includes("EDPFlutterApp") || localStorage.getItem("webView") == "true"

  const [username, setUsername] = useState(nativeApp ? userCredentialsContextValues?.username : localStorage.getItem("username"));
  const [userEmail, setUserEmail] = useState(nativeApp ? userCredentialsContextValues?.email : localStorage.getItem("UEmail"));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [accessToken, setAccessToken] = useState("");
  const [portalUser, setPortalUser] = useState(false);
  const { direction, setDirection } = useDirection();
  const lang = searchParams.get("language");

  useEffect(() => {
    // if (userAgent.includes("EDPFlutterApp")) {
    if (localStorage.getItem("webView") == "true" || userAgent.includes("EDPFlutterApp")) {
      setIsWebView(true)
    }
    else {
      setIsWebView(false)
    }
  }, [])


  //For native/webview app, from url we are taking language parameter and set language acceordingly in native app
  useEffect(() => {
    if (lang && (isWebView || localStorage.getItem("webView") === "true")) {
      i18n.changeLanguage(lang);
      if (window.location.pathname === "/" || window.location.pathname === "/home/") {
        localStorage.setItem('i18nextLng', lang);
        localStorage.setItem('i18nextLngNotLandingPage', lang);
      } else {
        localStorage.setItem('i18nextLngNotLandingPage', lang);
      }
      setDirection(lang === 'ar' ? 'rtl' : 'ltr');
    }

  }, [lang]);
  const updateTheme = (event) => {
    const newTheme = event.detail;
    theme = newTheme;
    applyTheme(elementInstances, theme, "Header")
  };
  useEffect(() => {
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, [])

  useEffect(() => {
    if (isWebView || localStorage.getItem("webView") === "true") {
      theme = nativeTheme;
      localStorage.setItem("theme", nativeTheme);

      document.body.className = `theme-${nativeTheme}`;
      window.dispatchEvent(new CustomEvent("themeChanged", { detail: nativeTheme }));

    }
  }, [theme])

  //Login and logout sync across all the tabs
  //Starts here  
  useEffect(() => {
    const userAgent = navigator.userAgent || "";
    const isNativeApp =
      localStorage.getItem("webView") === "true" ||
      userAgent.includes("EDPFlutterApp") ||
      isWebView;

    if (!isNativeApp) {
      // Initialize lastAuthState if not set
      if (sessionStorage.getItem('lastAuthState') === null) {
        const currentToken = localStorage.getItem('token');
        sessionStorage.setItem('lastAuthState', JSON.stringify(!!currentToken));
      }

      const syncAuthState = (eventSource = null) => {
        const token = localStorage.getItem('token');
        const newAuthState = !!token;
        const storedAuthState = JSON.parse(sessionStorage.getItem('lastAuthState'));

        // Skip if state didn't change
        if (newAuthState === storedAuthState) {
          if (isAuthenticated !== newAuthState) {
            setIsAuthenticated(newAuthState);
          }
          return;
        }

        // Update stored state
        sessionStorage.setItem('lastAuthState', JSON.stringify(newAuthState));

        // Determine if this is a cross-tab event
        const isCrossTabEvent = eventSource === 'storage'
        // || (eventSource === 'visibility' && !document.hidden);

        // Update React state immediately in current tab
        setIsAuthenticated(newAuthState);

        // Only refresh other tabs (not the one making the change)
        if (isCrossTabEvent) {
          window.location.reload();
        }
      };



      const handleStorageChange = (e) => {
        if (e.key === 'username') {
          syncAuthState('storage');
        }
      };

      // window.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('storage', handleStorageChange);

      // Initial sync without refresh
      syncAuthState();

      return () => {
        // window.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('storage', handleStorageChange);
      };
    }
  }, [isAuthenticated]);

  //Ends here

  useEffect(() => {
    const userAgent = navigator.userAgent || "";
    const isNativeApp = localStorage.getItem("webView") === "true" || userAgent.includes("EDPFlutterApp");

    // if (userAgent.includes("EDPFlutterApp")) {
    if (isNativeApp) {
      //if (!userCredentialsContextValues?.isContextValuesAvailable && !window.location.pathname.includes("sample-dashboard")) {

      if (!userCredentialsContextValues?.isContextValuesAvailable && source !== "sdm" && source !== "eadadmin" && !window.isSourceAdmin) {
        setIsWebView(true);
        localStorage.setItem("UEmail", "");
        localStorage.setItem("username", "");
        localStorage.setItem("UserId", "");
        //localStorage.setItem("groups", "");
        localStorage.setItem("token", "");
        localStorage.setItem("adtoken", "");
        setGlobalData(prev =>
          prev.map(module =>
            module.moduleName === "Header"
              ? { ...module, data: {} }
              : module
          )
        );
        setUserEmail(userCredentialsContextValues ? userCredentialsContextValues.email : "");
        setUsername(userCredentialsContextValues ? userCredentialsContextValues.username : "");
      }
    }
    else {
      setIsWebView(false);
    }
    if (window.isSourceAdmin && (URLJWTtoken == null || URLJWTtoken == "" || URLJWTtoken == undefined)) {
      URLJWTtoken = window.NativeToken;
    }
    if (URLJWTtoken) {
      // You can store this token in localStorage/sessionStorage if needed

      localStorage.setItem("token", URLJWTtoken);
      setGlobalData(prev =>
        prev.map(module =>
          module.moduleName === "Header"
            ? {
              ...module, // Keep the existing module structure
              data: {
                ...module.data, // Keep the existing data in Header
                token: URLJWTtoken, // Only update the token
              },
            }
            : module // Keep other modules unchanged
        )
      );
      getUserDetails();

    } else {
      console.log("No token found in URL, user is normal.");
    }

  }, [URLJWTtoken]);
  useEffect(() => {
    const userAgent = navigator.userAgent || "";

    // if (userAgent.includes("EDPFlutterApp")) {
    if (localStorage.getItem("webView") == "true" || userAgent.includes("EDPFlutterApp")) {
      setIsWebView(true);
      if (!username || username == "") {
        getUserDetails();
      }
    }
    else {
      setIsWebView(false);
      // Fixed issue where `isAuthenticated` was not triggering UI updates.
      // NOTE: Replaced earlier static assignment with React state logic in useEffect.
      // Old code is commented out below in this file for reference.
      if (
        getLocalStorageItem("username") !== "" &&
        getLocalStorageItem("username") !== null
      ) {
        setIsAuthenticated(true)
        setUserEmail(localStorage.getItem("UEmail"))
      }
    }
  }, [username])
  useEffect(() => {
    const handleRedirectResponse = async () => {
      setLoading(true);
      try {
        const authResult = await instance.handleRedirectPromise();

        if (!authResult) {
          // No token or auth result, user might have navigated to the page without logging in
          return;
        }

        const user = authResult.account;
        const token = authResult.accessToken;
        sessionStorage.setItem("adtoken", token);

        const username = authResult.account.username;
        sessionStorage.setItem("userEmail", username);
        localStorage.setItem("userEmail", username);
        setUserEmail(username);

        const apiUrl = `${process.env.REACT_APP_API_URL}/auth/ad-loginforWeb`;
        const requestBody = {
          Email: user.username,
          Username: user.username,
          DisplayName: user.name,
          ADUserId: user.localAccountId,
        };
        // await sharedLogin();
        await sendApiRequest(apiUrl, requestBody);
      } catch (error) {
        console.error("Error handling redirect response:", error);

      } finally {
        setLoading(false);
      }
    };
    const hash = window.location.hash;
    sharedLogin(hash);
    handleRedirectResponse();
  }, []);

  const sendApiRequest = async (url, body) => {
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message);
        setTimeout(() => setErrorMessage(""), 3000);
        return;
      }

      if (typeof data !== "undefined") {
        if (data.status && (data.status === 1 || data.status === 3)) {
          showAlert(t("insufficientPermission"), "error");
          setErrorMessage(t("insufficientPermission"), "error");
          setTimeout(() => setErrorMessage(""), 3000);
          return;
        }
      }
      const { username, jwtToken, role, userId, groups } = data;
      if (jwtToken !== "") {
        localStorage.setItem("token", jwtToken.token);
        localStorage.setItem("TokenExpTime", jwtToken.tokenExpirationTime);
        localStorage.setItem("username", username);
        localStorage.setItem("role", role);
        localStorage.setItem("UserId", userId);
        //localStorage.setItem("groups", JSON.stringify(groups));
        if (data.email) {
          localStorage.setItem("Email", data.email);
        }
        const _userEmail = getLocalStorageItem("userEmail");
        const _accessToken = getLocalStorageItem("adtoken");
        await checkIfPortalUser(_userEmail, _accessToken);
        // window.location.href = `${process.env.REACT_APP_BASE_URL}`; // Navigate to homepage
      } else {
        showAlert(t("UnauthorizedLogin"), "error");
      }
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
      } else {
        setErrorMessage(error.message);
        setTimeout(() => setErrorMessage(""), 3000);
      }
    } finally {
      setLoading(false);
    }
  };



  const sharedLogin = async (urlHash) => {

    /** check if access token is available in hash */
    const hash = window.location.hash || urlHash;
    if (hash && (hash.indexOf('access_token') > 0 || hash.indexOf('code') > 0)) {
      let _accessToken = null;

      // Check if access_token is in the hash
      if (hash.indexOf('access_token') > 0) {
        _accessToken = hash.split('access_token=')[1].split('&')[0];
      }
      // If access_token is not found, check for code
      else if (hash.indexOf('code') > 0) {
        _accessToken = hash.split('code=')[1].split('&')[0];
      }
      if (_accessToken) {
        setAccessToken(_accessToken);
        localStorage.setItem('PortalToken', _accessToken);
        const savedEmail = sessionStorage.getItem('userEmail');
        if (savedEmail) {
          setUserEmail(savedEmail); // Restore user email
        }
      }
      window.history.replaceState(null, "", `${process.env.REACT_APP_BASE_URL}`);
    }
  }
  const getUserDetails = async () => {
    const token = userCredentialsContextValues.token || localStorage.getItem("token"); // Retrieve token from storage

    if (!token) {
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Auth/get-user`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        if (window.isSourceAdmin) {
          setNativeAppAPIState(false)
        }
        throw new Error("Failed to fetch user details");
      }

      const data = await response.json();
      const decryptUserName = decryptUserId(data.username);
      const decryptEmail = decryptUserId(data.email);
      data.username = decryptUserName;
      data.email = decryptEmail;

      localStorage.setItem("UEmail", data.email);
      // localStorage.setItem("TokenExpTime", data.tokenExpirationTime);
      localStorage.setItem("username", data.username);
      localStorage.setItem("UserId", data.id);
      const groupNames = data.groups.map(item => item.groupName);
      const storedGroups = JSON.stringify(groupNames)
      //localStorage.setItem("groups", JSON.stringify(groupNames));
      const localStorageContextValues = {
        email: data.email,
        username: data.username,
        userId: data.id,
        //groups: storedGroups,
        isContextValuesAvailable: true
      };
      setGlobalData(prev =>
        prev.map(module =>
          module.moduleName === "Header"
            ? {
              ...module, // Keep the existing module structure
              data: {
                ...module.data, // Keep the existing data in Header
                ...localStorageContextValues, // Override only the updated values
              },
            }
            : module // Keep other modules unchanged
        )
      );

      setUsername(data.username);
      setUserEmail(data.email);
      setIsAuthenticated(true)
      if (window.isSourceAdmin) {
        setNativeAppAPIState(true)
      }

      // if(adToken!="" || adToken!=null || adToken!=undefined){
      //   await checkIfPortalUser(data.email, adToken);
      // }


      return data; // Contains userId and userName
    } catch (error) {
      if (window.isSourceAdmin) {
        setNativeAppAPIState(false)
      }
      const localStorageContextValues = {
        isContextValuesAvailable: false
      };
      setGlobalData(prev =>
        prev.map(module =>
          module.moduleName === "Header"
            ? {
              ...module, // Keep the existing module structure
              data: {
                ...module.data, // Keep the existing data in Header
                localStorageContextValues, // Override only the updated values
              },
            }
            : module // Keep other modules unchanged
        )
      );
      console.error("Error fetching user details:", error);
    } finally {
      setNativeAppAPIState(true)
    }
  };

  const checkIfPortalUser = async (_userEmail, _accessToken) => {
    const exists = await checkIfUserExistsInArcGISPortal(_userEmail, window.arcgis.portalUrl, _accessToken);
    localStorage.setItem('portalUser', exists);
    if (exists) {
      console.log(`user ${_userEmail} exists in portal`);
      console.log(`redirecting for portal authentication`);
      /**authenticate user with ArcGIS portal */
      redirectToIDP(window.arcgis.portalUrl, window.arcgis.samlLogin, window.arcgis.appID);
    } else {
      // window.location.href = `${process.env.REACT_APP_BASE_URL}`; // Navigate to homepage    
      navigate(0)
    }
  }

  // Handle toggle change
  const handleToggleChange = () => {
    toggleTheme();
    setIsChecked(!isChecked);

  };
  const handleDropdownToggle = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("closeAllSearchWidgets"));
    setIsHeaderProfileDropdownOpen(!isHeaderProfileDropdownOpen);
    setUsername(nativeApp ? userCredentialsContextValues?.username : localStorage.getItem("username"));
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenNewHome, setIsDropdownOpenNewHome] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const toggleDropdownNewHome = () => {
    setIsDropdownOpenNewHome((prevState) => !prevState);
  };


  // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (!event.target.closest(".profile-head")) {
  //       setIsHeaderProfileDropdownOpen(false);
  //     }
  //   };

  //   document.addEventListener("click", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, []);
  const [Email, setEmail] = useState(""); //need for myinfo and changepassword
  const [isMenuVisible, setIsMenuVisible] = useState(false);


  const handleMenuClick = () => {
    setIsMenuVisible(true);
  };

  const handleCloseClick = () => {
    setIsMenuVisible(false);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setIsSidebarVisible(false);
  }
  const handleMyInfoShow = () => {
    setInfoShow(true);
    setIsMenuVisible(false);
    setIsSidebarVisible(false);
    setSidebar(false);
  }
  const handleChangepasswordclose = () => {
    setShowchangePassword(false);
    setInfoShow(true);
  }
  const handleMyInfoClose = () => setInfoShow(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const handleEditModeChange = (editMode) => setIsEditMode(editMode);
  const handleRightMenuItemClose = () => setRightMenuSelectedItem(null);
  const sidebartoggle = (e) => {
    document.querySelector("body").classList.toggle("toggle-sidebar");
    if (source === "sdm") {
      document.querySelector("body").classList.toggle("sdmMobFix");
    }
    setSidebar(true);
  };

  //To hide the sidebar when click on any menuitem from sidebar menu
  useEffect(() => {
    if (isSidebarVisible) {
      setIsSidebarVisible(false)
    }

  }, [rightMenuSelectedItem])

  const handleLogout = async () => {
    try {
      if (accounts.length > 0) {
        await azureLogout(instance, accounts[0]);
      }
      await logAuditEntry(
        t,
        navigate
      );
      resetUserGroups();
      // localStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("role");
      localStorage.removeItem("UserId");
      localStorage.removeItem("Email");
      sessionStorage.clear();
      setGlobalData(prev =>
        prev.map(module =>
          module.moduleName === "Header"
            ? { ...module, data: {} }
            : module
        )
      );
      // sessionStorage.setItem("isEnvioportalRefreshed", "false");
      // sessionStorage.setItem("isEnvioportalRefreshed", "false");
      const mobHeaderElement = document.querySelector('.signUp-mobHeader');
      if (mobHeaderElement) {
        mobHeaderElement.classList.remove('d-flex');
      }
      //navigate("/");
      window.location.href = `${process.env.REACT_APP_BASE_URL}`;// Navigate to homepage
    } catch (error) {
      console.error("Error during logout:", error);
      throw error;
    }
  };


  // Fixed issue where `isAuthenticated` was not triggering UI updates.
  // Moved logic to useEffect with state update to ensure reactivity.

  // let translatedWelcomeMessage = t("welcomeMessage");
  // var userEmail;
  // if (
  //   getLocalStorageItem("username") !== "" &&
  //   getLocalStorageItem("username") !== null
  // ) {
  //   translatedWelcomeMessage = getLocalStorageItem("username");
  //   //userEmail=getLocalStorageItem('Email')
  //   userEmail = localStorage.getItem('UEmail')
  //   isAuthenticated = true;
  // }

  useEffect(() => {

    if (getLocalStorageItem("logoutInProgress") === "true") {

      removeLocalStorageItem("logoutInProgress");
      logAuditEntry(
        t,
        navigate
      );
      resetUserGroups();
      localStorage.clear();
      setGlobalData(prev =>
        prev.map(module =>
          module.moduleName === "Header"
            ? { ...module, data: {} }
            : module
        )
      );
      // sessionStorage.clear();
      setIsAuthenticated(false)
      navigate("/");
    }

    // const handleScroll = () => {
    //   const navbar = document.querySelector('.navbar');
    //   if (window.scrollY > 200) {
    //     navbar.classList.add('navbar-scrolled');
    //     setIsScrolled(true);
    //   } else {
    //     navbar.classList.remove('navbar-scrolled');
    //     setIsScrolled(false);
    //   }
    // };
    if (isMainPage) {
      const handleScroll = () => {
        const navbar = document.querySelector(".navbar");
        if (window.scrollY > 20) {
          navbar.classList.add("navbar-scrolled");
          setIsScrolled(true);
        } else {
          navbar.classList.remove("navbar-scrolled");
          setIsScrolled(false);
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [navigate, t, resetUserGroups, isMainPage]);

  const rightMenuHeadingsMap = {
    relatedLinks: t("RelatedLinkstitle"),
    sitemap: t("sitemaptitle"),
    feedback: t("feedbacktitle"),
    about: t("About"),
  };

  const getContentForRightMenu = (menu) => {
    switch (menu) {
      case "relatedLinks":
        return <RelatedLinks />;
      case "sitemap":
        return <Sitemap />;
      case "feedback":
        return (
          <Feedback
            onCancel={handleRightMenuItemClose}
            setRightMenuSelectedItem={setRightMenuSelectedItem}
            showThankYouModal={showThankYouModal}
            setShowThankYouModal={setShowThankYouModal}
          />
        );
      case "about":
        return <About />;
      default:
        return null;
    }
  };

  // const handleHelpClick = () => {
  //   const currentLang = i18n.language;
  //   //  let helpLink = window.aboutLinks[currentLang];
  //   const pdfUrl = `${process.env.REACT_APP_BASE_URL}/Application Usage and Administrative Guide.pdf`;
  //   // if (!pdfUrl || typeof pdfUrl !== "string" || !isValidUrl(pdfUrl)) {
  //   //   return;
  //   // }
  //   window.open(pdfUrl, "_blank");
  // };
  const handleHelpClick = (e) => {
    e.preventDefault();
    try {
      const origin =
        (process.env.REACT_APP_BASE_URL).replace(/\/+$/, '');
      //const pdfUrl = `${process.env.REACT_APP_BASE_URL}/Application Usage and Administrative Guide.pdf`;
      const pdfUrl = `${process.env.REACT_APP_BASE_URL}/docsify-help/help.html`;
      const localWebView = localStorage.getItem("webView");
      let webView = false;

      if (localWebView === "true" || userAgent.includes("EDPFlutterApp")) {
        webView = true;
      }
      if (webView) {
        // In WebView: navigate within the same window
        window.location.href = `${origin}/docsify-help/help.html`;
      } else {
        // In browser: open new tab
        window.open(`${origin}/docsify-help/help.html`, '_blank');
        //window.open(`${process.env.REACT_APP_BASE_URL}//docsify-help/help.html`, '_blank');
      }
      if (!pdfUrl) {
        console.error("HTML Page is undefined");
        return;
      }

    } catch (error) {
      //alert(`Error opening PDF:,${error} `)
      console.error("Error opening PDF:", error);
    }
  };
  const handleCloseSaveConfirmation = () => setShowSaveConfirmation(false);
  const handleCloseResetConfirmation = () => setShowResetConfirmation(false);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {sidebar && (
        <Sidebar source={source} callingFrom={'header'} onViewInfoClick={handleMyInfoShow} handleLogout={handleLogout} mobileSidebar={true} />
      )}
      <nav
        className={`navbar navbar-expand-xl p-0 fixed-top 
          ${source === "home"
            ? "enviportal-header land-left0"
            : source === "enviroportal"
              ? "enviportal-header portalheader hd-admin-right newaddIconleft"
              : source === "sdm"
                ? "enviportal-header colorbg sdm-headerDark"
                : source === "eadadmin"
                  ? "enviportal-header colorbg hd-admin-right"
                  : source === "permit-dashboard"
                    ? "enviportal-header colorbg hd-admin-right permitDashHeadFix"
                    : "enviportal-header colorbg hd-admin-right"
          } 
          ${theme === "dark"
            ? "navbar-dark header-light-green"
            : "navbar-light header-light-green"
          }
          ${isScrolled ? "navbar-scrolled" : ""}
          ${isMarineSearchHidden ? 'analyticHeaderZindex' : ''}
          ${navClass || ""}
          `}
      >
        <div className="d-flex px-5-left align-items-center w-100 position-relative">
          <Link
            className="navbar-brand position-relative"
            to="https://www.ead.gov.ae/en"
            target="_blank"
          >
            <img
              src={
                isMainPage
                  ? isScrolled
                    ? ScrollWhiteLogo
                    : logo
                  : ScrollWhiteLogo
              }
              className="w-192"
              // style={{ width: "150px", height: "auto" }}
              alt="Logo"
            />
          </Link>

          <div className={`profile-lang-switcher onEnviroSft ${isMarineSearchHidden ? 'analyticHeaderHide' : ''}`}>
            <nav className="header-nav">
              <ul className="d-flex align-items-center">
                <>
                  {source === "enviroportal" && (
                    <li className={`for-aoi-hide ${isMarineSearchHidden ? 'analSearchHide' : ''}`}>
                      <SearchComponent
                        mapview={mapview}
                        type={["map", "data"]}
                        isMobile={false}
                      />
                    </li>
                  )}

                  <>
                    <li>
                      <div className="align-items-center sm-justify-end sm-header-none mob-settingHeader">
                        <LanguageSwitcher />
                        <ThemeSwitcher />
                      </div>
                    </li>

                    {isAuthenticated ? (
                      <li className={`nav-item dropdown pe-2 profile-head mob-settingHeader for-aoi-hide ${isMarineSearchHidden ? 'analSearchHide' : ''}`}>
                        <button
                          className="nav-link nav-profile d-flex align-items-center pe-0"
                          data-bs-toggle="dropdown"
                          onClick={handleDropdownToggle}
                        >
                          <CgProfile size={24} style={{ color: "#fff" }} />
                          <span className="dropdown-toggle">
                            {/* <RiArrowDropDownLine /> */}
                            <img src={`${process.env.PUBLIC_URL}/images/drop-arrow.svg`} alt="" />

                          </span>
                        </button>
                        <ul className={`cc dropdown-menu dropdown-menu-end dropdown-menu-arrow profile 
                          ${(source === "enviroportal" || source === "home") ? 'enviroportal-Halfsidebar enviroportalProf' : ''}
                          `
                        }
                        >
                          <li className="dropdown-header ProfileBig">
                            {source === "enviroportal" ? (
                              <button className="close-btn mb-2" onClick={() => setIsOpen(false)}>
                                &times;
                              </button>
                            ) : ''}
                            <div className="ProfileBig --avatarSec">

                              <img src={`${process.env.PUBLIC_URL}/images/ph_user.svg`} alt="" />
                            </div>
                            <div className="NameDiv">
                              <h6 className="profileName">
                                {" "}
                                {/* {translatedWelcomeMessage} */}
                                {username}
                              </h6>
                              <div className=" useremail" >
                                {" "}
                                {userEmail}
                              </div>
                              {!isWebView &&
                                <button
                                  onClick={handleMyInfoShow}
                                  className="btn btn-primary mt-2 vif"
                                  style={{
                                    color: theme === "dark" ? "#fff!important" : "inherit",
                                  }}
                                >
                                  {t("View Info")}
                                </button>
                              }
                            </div>
                          </li>

                          <li className="px-3">
                            <hr className="dropdown-divider" />
                          </li>
                          {source === "enviroportal" ? (
                            <li>
                              <div
                                className="mt-2 enviro-userinfo-sidebar cv"
                                style={{ overflowY: "auto" }}
                              >
                                <ul className="nav flex-column">
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      onClick={() => setRightMenuSelectedItem("relatedLinks")}
                                    >
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/relatedlink-icon.svg`}
                                      />{" "}
                                      {t("RelatedLinkstitle")}
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      onClick={() => setRightMenuSelectedItem("feedback")}
                                    >
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/sendfeedback-icon.png`}
                                      />{" "}
                                      {t("Send Feedback")}
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      onClick={() => setRightMenuSelectedItem("sitemap")}
                                    >
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/sitemap.svg`}
                                      />{" "}
                                      {t("View Site Map")}
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      onClick={() => setRightMenuSelectedItem("about")}
                                    >
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/aboutIcon.svg`}
                                      />{" "}
                                      {t("About")}
                                    </Link>
                                  </li>

                                  <li className="nav-item">
                                    <Link className="nav-link" onClick={handleHelpClick}>
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/accesshelp-icon.svg`}
                                      />{" "}
                                      {t("Access Help")}
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          ) : ''}

                          {source === "home" ? (
                            <li>
                              <div
                                className="mt-2"
                              >
                                <ul className="nav flex-column araFontWeightSix">
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/AboutUs"
                                    >
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/aboutIcon.svg`}
                                      />{" "}
                                      {t("About Us")}
                                    </Link>
                                  </li>

                                  <li className="nav-item">
                                    <Link className="nav-link"
                                      to="#"
                                      onClick={() => {
                                        const direction = document.body.getAttribute("dir");
                                        const contactUrl =
                                          direction === "rtl"
                                            ? "https://ead.gov.ae/ar-AE/ContactUs"
                                            : "https://www.ead.gov.ae/en/ContactUs";

                                        window.open(contactUrl, "_blank");
                                      }}
                                    >
                                      <img
                                        alt=""
                                        className="me-3"
                                        style={{ width: "2.188rem", height: "2.188rem" }}
                                        src={`${process.env.PUBLIC_URL}/images/accesshelp-icon.svg`}
                                      />{" "}
                                      {t("Contact Us")}
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          ) : ''}
                          <li className="px-3">
                            <hr className="dropdown-divider" />
                          </li>
                          {!isWebView &&
                            <li className={`pt-2 
                              ${source === "enviroportal" ? 'envProf-signout logHomePosAb' : ''}
                              ${source === "home" ? "logHomePosAb" : ""}`
                            }
                            >
                              <Link
                                className="dropdown-item d-flex align-items-center"
                                onClick={handleLogout}
                              >
                                <span className="LogoutIcon">
                                  <img src={`${process.env.PUBLIC_URL}/images/logouticon.svg`} alt="" />
                                </span>
                                <span className="textLogoutWhite">
                                  {" "}
                                  {t("logout")}{" "}
                                </span>
                              </Link>
                            </li>
                          }
                        </ul>
                      </li>
                    ) : (
                      <>
                        {!isWebView &&
                          <>
                            <li className={`nav-item align-items-center SigninDiv mob-settingHeader for-aoi-hide ${isMarineSearchHidden ? 'analSearchHide' : ''}`}>
                              <Link
                                className={`nav-link ${theme === "dark" ? "text-light" : "text-dark"}`}
                                onClick={handleShow}
                              >
                                <button
                                  type="button"
                                  className="btn btn-success signin-btn hoverSignbtn mob-settingHeader"
                                >
                                  {t("SignIn")}
                                </button>
                              </Link>
                            </li>
                            {source === "home" && (
                              <li className={`nav-item align-items-center SigninDiv mob-settingHeader for-aoi-hide`}>
                                <button
                                  className="nav-link nav-profile d-flex align-items-center pe-0 leftHambShift "
                                  data-bs-toggle="dropdown"
                                  onClick={toggleDropdownNewHome}
                                >
                                  <img src={`${process.env.PUBLIC_URL}/images/headerhamberger.svg`} />
                                </button>
                                <ul className={`zz dropdown-menu dropdown-menu-end dropdown-menu-arrow profile enviroportal-Halfsidebar enviroportalProf ${isDropdownOpenNewHome ? "show" : ""}`}>
                                  <li className="dropdown-header ProfileBig d-flex align-items-center margin1Rem">
                                    {source === "home" ? (
                                      <button className="close-btn mb-2" onClick={toggleDropdownNewHome}>
                                        &times;
                                      </button>
                                    ) : ''}
                                    <div className="ProfileBig --avatarSec">

                                      <img src={`${process.env.PUBLIC_URL}/images/ph_user.svg`} alt="" />
                                    </div>
                                  </li>

                                  <li className="px-3">
                                    <hr className="dropdown-divider" />
                                  </li>

                                  <li>
                                    <div
                                      className="mt-2"
                                    >
                                      <ul className="nav flex-column araFontWeightSix">
                                        <li className="nav-item">
                                          <Link
                                            className="nav-link"
                                            to="/AboutUs"
                                          >
                                            <img
                                              alt=""
                                              className="me-3"
                                              style={{ width: "2.188rem", height: "2.188rem" }}
                                              src={`${process.env.PUBLIC_URL}/images/aboutIcon.svg`}
                                            />{" "}
                                            {t("About Us")}
                                          </Link>
                                        </li>

                                        <li className="nav-item">
                                          <Link className="nav-link"
                                            to="#"
                                            onClick={() => {
                                              const direction = document.body.getAttribute("dir");
                                              const contactUrl =
                                                direction === "rtl"
                                                  ? "https://ead.gov.ae/ar-AE/ContactUs"
                                                  : "https://www.ead.gov.ae/en/ContactUs";

                                              window.open(contactUrl, "_blank");
                                            }}
                                          >
                                            <img
                                              alt=""
                                              className="me-3"
                                              style={{ width: "2.188rem", height: "2.188rem" }}
                                              src={`${process.env.PUBLIC_URL}/images/accesshelp-icon.svg`}
                                            />{" "}
                                            {t("Contact Us")}
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </li>

                                </ul>
                              </li>
                            )}

                          </>
                        }
                        {source === "enviroportal" && (
                          <>
                            <li className={`nav-item dropdown pe-2 newToggleRespShift profile-head mob-settingHeader for-aoi-hide ${isMarineSearchHidden ? 'analSearchHide' : ''}`}>
                              <button
                                className="nav-link nav-profile d-flex align-items-center pe-0 leftHambShift "
                                data-bs-toggle="dropdown"
                                onClick={toggleDropdown}
                              >
                                <img src={`${process.env.PUBLIC_URL}/images/headerhamberger.svg`} />
                              </button>
                              <ul className={`zz dropdown-menu dropdown-menu-end dropdown-menu-arrow profile enviroportal-Halfsidebar enviroportalProf ${isDropdownOpen ? "show" : ""}`}>
                                <li className="dropdown-header ProfileBig d-flex align-items-center margin1Rem">
                                  {source === "enviroportal" ? (
                                    <button className="close-btn mb-2" onClick={toggleDropdown}>
                                      &times;
                                    </button>
                                  ) : ''}
                                  <div className="ProfileBig --avatarSec">

                                    <img src={`${process.env.PUBLIC_URL}/images/ph_user.svg`} alt="" />
                                  </div>
                                </li>

                                <li className="px-3">
                                  <hr className="dropdown-divider" />
                                </li>

                                <li>
                                  <div
                                    className="mt-2 enviro-userinfo-sidebar ab"
                                    style={{ overflowY: "auto" }}
                                  >
                                    <ul className="nav flex-column">
                                      <li className="nav-item">
                                        <Link
                                          className="nav-link"
                                          onClick={() => setRightMenuSelectedItem("relatedLinks")}
                                        >
                                          <img
                                            alt=""
                                            className="me-3"
                                            style={{ width: "2.188rem", height: "2.188rem" }}
                                            src={`${process.env.PUBLIC_URL}/images/relatedlink-icon.svg`}
                                          />{" "}
                                          {t("RelatedLinkstitle")}
                                        </Link>
                                      </li>
                                      <li className="nav-item">
                                        <Link
                                          className="nav-link"
                                          onClick={() => setRightMenuSelectedItem("feedback")}
                                        >
                                          <img
                                            alt=""
                                            className="me-3"
                                            style={{ width: "2.188rem", height: "2.188rem" }}
                                            src={`${process.env.PUBLIC_URL}/images/sendfeedback-icon.png`}
                                          />{" "}
                                          {t("Send Feedback")}
                                        </Link>
                                      </li>
                                      <li className="nav-item">
                                        <Link
                                          className="nav-link"
                                          onClick={() => setRightMenuSelectedItem("sitemap")}
                                        >
                                          <img
                                            alt=""
                                            className="me-3"
                                            style={{ width: "2.188rem", height: "2.188rem" }}
                                            src={`${process.env.PUBLIC_URL}/images/sitemap.svg`}
                                          />{" "}
                                          {t("View Site Map")}
                                        </Link>
                                      </li>
                                      <li className="nav-item">
                                        <Link
                                          className="nav-link"
                                          onClick={() => setRightMenuSelectedItem("about")}
                                        >
                                          <img
                                            alt=""
                                            className="me-3"
                                            style={{ width: "2.188rem", height: "2.188rem" }}
                                            src={`${process.env.PUBLIC_URL}/images/aboutIcon.svg`}
                                          />{" "}
                                          {t("About")}
                                        </Link>
                                      </li>

                                      <li className="nav-item">
                                        <Link className="nav-link" onClick={handleHelpClick}>
                                          <img
                                            alt=""
                                            className="me-3"
                                            style={{ width: "2.188rem", height: "2.188rem" }}
                                            src={`${process.env.PUBLIC_URL}/images/accesshelp-icon.svg`}
                                          />{" "}
                                          {t("Access Help")}
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </li>

                              </ul>
                            </li>

                          </>
                        )}
                      </>
                    )}
                  </>

                  {(source === "enviroportal" || source === "permit-dashboard") && (
                    <li className="check-mob-section d-none d-sm-none d-md-none">
                      <div className="align-items-center sm-justify-end sm-header-none">
                        {/* <LanguageSwitcher /> */}
                        <ThemeSwitcher />
                      </div>
                    </li>
                  )}


                  {((isWebView && source === "enviroportal") || (isWebView && source === "eadadmin") || (isWebView && source === "sdm") || !isWebView) && <>
                    <li className="d-block d-sm-block d-md-block d-lg-block d-xl-none ps-3 mobps3">
                      {(source === "eadadmin" || source === "sdm") && (
                        <GiHamburgerMenu
                          size={22}
                          color="white"
                          onClick={sidebartoggle}
                        />
                      )}
                    </li>

                    <li className={`for-aoi-hide ${isMarineSearchHidden ? 'analSearchHide' : ''} ${(source === "enviroportal" || source === "permit-dashboard" && isAuthenticated) ? 'enviMenu' : ''}`}>
                      {(source === "enviroportal" || source === "permit-dashboard") && (
                        <RxHamburgerMenu
                          className="Ham"
                          size={20}
                          color="white"
                          onClick={toggleSidebar}
                        />
                      )}
                    </li></>
                  }

                  {/*---- for landing page NavigationBar Responsive Start--- */}
                  {!isWebView && <li className="d-block d-sm-block d-md-none">
                    {source != "Catalogue" && source === "home" && (
                      <FiMenu
                        size={22}
                        color="white"
                        onClick={handleMenuClick}
                      />
                    )}
                  </li>
                  }
                  {/*---- for landing page NavigationBar Responsive End--- */}
                </>
              </ul>
            </nav>
          </div>
        </div>
      </nav>
      {/*---- for landing page NavigationBar Responsive End--- */}
      {isMenuVisible && (
        <div className="mobHome-Header common-MobileHeader">
          <div className="col-sm-12 text-right">
            <RxCross2
              onClick={handleCloseClick}
              size={22}
              style={{ color: theme === "dark" ? "#fff" : "inherit" }}
            />
          </div>
          {isAuthenticated ? (<div className="col-sm-12 infoSection-header-mobile d-flex Pr-20">
            <div className="ProfileBig">
              {/* <CgProfile size={125} /> */}
              <img src={`${process.env.PUBLIC_URL}/images/profilepic.svg`} alt="" />
            </div>
            <div className="row mt-1 mobile-header-Infoheading">
              <div
                className="col-sm-12 name-text omnes-medium-font"
                style={{ color: theme === "dark" ? "#fff" : "inherit" }}
                ref={(el) => { if (el) elementInstances["div1"] = el; }}
              >
                {" "}
                {/* {translatedWelcomeMessage} */}
                {username}
              </div>
              <div
                className="col-sm-12 email-text omnes-regular-font"
                style={{ color: theme === "dark" ? "#fff" : "inherit" }}
                ref={(el) => { if (el) elementInstances["div4"] = el; }}
              >
                {" "}
                {userEmail}
              </div>
              <div className="row d-flex align-items-center mobile-header-Infoheading">
                <div className="btn-container myinfo-btn mt-3 mb-2 name-text">
                  {!isWebView && <>
                    <button className="btn btn-primary Lr-3" onClick={handleMyInfoShow} >{t('View Info')}</button>
                    <div className="row mt-1 Logout-div">
                      <button className="btn btn-primary w-100" onClick={handleLogout}>{t('logout')}</button>
                    </div>
                  </>}
                </div>
              </div>
            </div>
          </div>
          ) : (
            <div className="signUp-mobHeader text-center mb-3 ">
              <img alt=""
                className="mb-4"
                src={`${process.env.PUBLIC_URL}/images/signProfile.svg`}
                style={{ width: "4.063rem", height: "4.063rem" }}
              />
              <p>
                <Link
                  onClick={handleShow}
                >
                  <button type="button" className="btn btn-success signin-mob-btn">
                    {t("SignIn")}
                  </button>
                </Link>
              </p>
            </div>
          )}
          <hr className="m-4" />
          <div className="col-sm-12 theme-langSection-Sidebar pe-3 ps-3">
            <div className="col-sm-12 setting-item drModeChk1">
              <div className="icon-text d-flex align-items-center">
                <span className="icon">
                  {theme === "dark" ? (
                    <GoSun
                      className="me-2"
                      style={{ color: "#ffffff" }}
                      size={20}
                    />
                  ) : (
                    <BsMoonStars
                      className="me-1"
                      style={{ color: "#575353" }}
                      size={20}
                    />
                  )}
                </span>
                <span className="modetext">
                  {theme === "dark" ? t("Light Mode") : t("Dark Mode")}
                </span>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleToggleChange}
                />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="col-sm-12">
              <LanguageSwitcher />
            </div>
            {source === "home" ? (
              <li className="forHome-mob-show-two">
                <div
                  className="mt-3"
                >
                  <ul className="nav flex-column araFontWeightSix">
                    <li className="nav-item mb-3">
                      <Link
                        className="nav-link p-0"
                        to="/AboutUs"
                      >
                        <img
                          alt=""
                          className="me-3"
                          style={{ width: "2.188rem", height: "2.188rem" }}
                          src={`${process.env.PUBLIC_URL}/images/aboutIcon.svg`}
                        />{" "}
                        {t("About Us")}
                      </Link>
                    </li>

                    <li className="nav-item mb-3">
                      <Link className="nav-link p-0"
                        to="#"
                        onClick={() => {
                          const direction = document.body.getAttribute("dir");
                          const contactUrl =
                            direction === "rtl"
                              ? "https://ead.gov.ae/ar-AE/ContactUs"
                              : "https://www.ead.gov.ae/en/ContactUs";

                          window.open(contactUrl, "_blank");
                        }}
                      >
                        <img
                          alt=""
                          className="me-3"
                          style={{ width: "2.188rem", height: "2.188rem" }}
                          src={`${process.env.PUBLIC_URL}/images/accesshelp-icon.svg`}
                        />{" "}
                        {t("Contact Us")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            ) : ''}
          </div>

          <Link
            to="https://www.ead.gov.ae/en"
            className="footerMobile-logo"
            target="_blank"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/${theme === "dark" ? "scrollwhitelogo.svg" : "newLogo.svg"
                }`}
              alt="Logo"
              className=""
            />
          </Link>
        </div>
      )}
      {/*---- for landing page NavigationBar Responsive End--- */}

      {/* sidebar half section */}
      {isSidebarVisible && (
        <div className={`enviroportal-Halfsidebar ${source === "permit-dashboard" ? "cliclPermitHiddenHeader" : ""}`}>
          <button className="close-btn mb-2" onClick={toggleSidebar}>
            &times;
          </button>
          <div className="mobHome-Header">
            <div className="col-sm-12 text-right d-none"></div>
            {isAuthenticated ? (<div className="col-sm-12 infoSection-header-mobile ">
              <div className="row mt-1 mobile-header-Infoheading">
                <div
                  className="col-sm-12 name-text omnes-medium-font ps-3"
                  style={{ color: theme === "dark" ? "#fff" : "inherit" }}
                  ref={(el) => { if (el) elementInstances["div2"] = el; }}
                >
                  {" "}
                  {/* {translatedWelcomeMessage} */}
                  {username}
                </div>
                <div
                  className="col-sm-12 email-text omnes-regular-font ps-3"
                  style={{ color: theme === "dark" ? "#fff" : "inherit" }}
                  ref={(el) => { if (el) elementInstances["div3"] = el; }}
                >
                  {" "}
                  {userEmail}
                </div>
              </div>
              {!isWebView && <div className="d-flex align-items-center envi">
                <div className="btn-container myinfo-btn mt-3 mb-2">
                  <Link
                    to=""
                    onClick={handleMyInfoShow}
                  >
                    <button className="btn btn-success ms-0">{t('View Info')}</button>
                  </Link>
                </div>
                <div className="btn-container myinfo-btn mt-3 mb-2">
                  <Link
                    className="dropdown-item d-flex justify=content-center align-items-center"
                    onClick={handleLogout}
                  >
                    <button className="btn btn-logout me-3">{t('logout')}</button>
                  </Link>
                </div>
              </div>}
            </div>
            ) : (
              !isWebView && <div className="signUp-mobHeader text-center mb-3">
                <img alt=""
                  className="mb-4"
                  src={`${process.env.PUBLIC_URL}/images/signProfile.svg`}
                  style={{ width: "65px", height: "65px" }}
                />
                <p>
                  <Link
                    onClick={handleShow}
                  >

                    <button type="button" className="btn btn-success signin-mob-btn">
                      {t("SignIn")}
                    </button>
                  </Link>

                </p>
              </div>
            )}
            {!isWebView && <hr className="mb-4 mt-4" />}
            <div className="col-sm-12 theme-langSection-Sidebar">
              <div className="col-sm-12 setting-item drModeChk1">
                <div className="icon-text d-flex align-items-center">
                  <span className="icon">
                    {theme === "dark" ? (
                      <GoSun
                        className="me-2"
                        style={{ color: "#ffffff" }}
                        size={20}
                      />
                    ) : (
                      <BsMoonStars
                        className="me-1"
                        style={{ color: "#575353" }}
                        size={20}
                      />
                    )}
                  </span>
                  <span className="modetext">
                    {theme === "dark" ? t("Light Mode") : t("Dark Mode")}
                  </span>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleToggleChange}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="col-sm-12">
                <LanguageSwitcher />
              </div>
            </div>
          </div>
          <div
            className="mt-2"
            style={{ height: "calc(100vh - 18.75rem)", overflowY: "scroll" }}
          >
            <ul className="nav flex-column">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  onClick={() => setRightMenuSelectedItem("relatedLinks")}
                >
                  <img
                    alt=""
                    className="me-3"
                    style={{ width: "2.188rem", height: "2.188rem" }}
                    src={`${process.env.PUBLIC_URL}/images/relatedlink-icon.svg`}
                  />{" "}
                  {t("RelatedLinkstitle")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  onClick={() => setRightMenuSelectedItem("feedback")}
                >
                  <img
                    alt=""
                    className="me-3"
                    style={{ width: "2.188rem", height: "2.188rem" }}
                    src={`${process.env.PUBLIC_URL}/images/sendfeedback-icon.png`}
                  />{" "}
                  {t("Send Feedback")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  onClick={() => setRightMenuSelectedItem("sitemap")}
                >
                  <img
                    alt=""
                    className="me-3"
                    style={{ width: "2.188rem", height: "2.188rem" }}
                    src={`${process.env.PUBLIC_URL}/images/sitemap.svg`}
                  />{" "}
                  {t("View Site Map")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  onClick={() => setRightMenuSelectedItem("about")}
                >
                  <img
                    alt=""
                    className="me-3"
                    style={{ width: "2.188rem", height: "2.188rem" }}
                    src={`${process.env.PUBLIC_URL}/images/aboutIcon.svg`}
                  />{" "}
                  {t("About")}
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" onClick={handleHelpClick}>
                  <img
                    alt=""
                    className="me-3"
                    style={{ width: "2.188rem", height: "2.188rem" }}
                    src={`${process.env.PUBLIC_URL}/images/accesshelp-icon.svg`}
                  />{" "}
                  {t("Access Help")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
      {rightMenuSelectedItem && (
        <Modal
          show={rightMenuSelectedItem != null}
          onHide={handleRightMenuItemClose}
          size={
            ["sitemap", "about"].includes(rightMenuSelectedItem)
              ? "lg modal-dialog-centered"
              : "md modal-dialog-centered"
          }
          className={`halfsidebar-modals ${rightMenuSelectedItem === "sitemap" ? "sideMapModalInc" : ""
            }`}
        >
          <Modal.Header
            closeButton
            className={`ps-0 pe-0 ${rightMenuSelectedItem === "about" ? "pb-2" : "pb-3"
              }`}
            style={
              rightMenuSelectedItem === "about" ? { borderBottom: "none" } : {}
            }
          >
            <Modal.Title>
              <h5 className="mb-0" style={{ color: "#000" }}>
                {" "}
                <strong>
                  {rightMenuSelectedItem === "about" ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/images/${theme === "dark" ? "scrollwhitelogo.svg" : "newLogo.svg"
                        }`}
                      alt="Logo"
                      style={{ width: "165px", height: "51px" }}
                    />
                  ) : (
                    rightMenuHeadingsMap[rightMenuSelectedItem]
                  )}
                </strong>
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 halfsidebar-modal-body ps-0 pe-0">
            {getContentForRightMenu(rightMenuSelectedItem)}
          </Modal.Body>
        </Modal>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        size="lg modal-dialog-centered SignupModals"
        className="modal-content-radius landing-modal-bg "
        style={{ zIndex: 9999999999 }}
        backdrop="static" // Prevent closing by clicking outside
      >
        {/* <Modal.Header closeButton className="border-btm-0 pe-4 pt-3 pb-0"> */}
        <Modal.Header closeButton className="border-btm-0">
          {" "}
        </Modal.Header>
        {/* <Modal.Body className="pt-0 sm-full-ht pb-5"> */}

        <Modal.Body className=" sm-full-ht">
          <SignInModal
            handleClose={handleClose}
            setShowResetConfirmation={setShowResetConfirmation}

          />
        </Modal.Body>
      </Modal>

      {/* change password */}
      <Modal
        show={ShowchangePassword}
        onHide={handleChangepasswordclose}
        size="dialog-centered"
        className=""
        style={{ zIndex: 9999999999 }}
        backdrop="static"
      >
        <Modal.Header closeButton className="border-btm-0 pe-4 pt-3 pb-0">
          {" "}
          <h5 className="omnes-medium-font pt-1 w-100">
            {" "}
            {t("changePassword")}
          </h5>
        </Modal.Header>
        <Modal.Body className="pt-0 sm-full-ht pb-5">
          <ChangePasswordPage
            handleChangepasswordclose={handleChangepasswordclose}
            setShowSaveConfirmation={setShowSaveConfirmation}
            Email={Email}
            setEmail={setEmail}
          />
        </Modal.Body>
      </Modal>

      {/* alert for changed password */}
      <Modal
        className="save-confirmation-modal"
        size="dialog-centered"
        show={showSaveConfirmation}
        onHide={handleCloseSaveConfirmation}
        backdrop="static"
      >
        <Modal.Header closeButton className="border-btm-0 pe-4 pt-3 pb-0">
          {" "}
        </Modal.Header>
        <Modal.Body>
          <div className="col-sm-12 text-center">
            <img
              className="img-fluid gif-wid"
              src={`${process.env.PUBLIC_URL}/images/confirm-sucessfully.gif`}
              alt="Save Confirmation"
            />
          </div>
          <div className="col-sm-12 text-center mb-5">
            <h4 className="omnes-medium-font mb-0"> {t("newPassword")} </h4>
            <h4 className="omnes-medium-font">
              {" "}
              {t("confirmedSuccessfully")}{" "}
            </h4>
            <p className="omnes-regular-font">
              {t("successfullyConfirmPassword")}
            </p>
          </div>
        </Modal.Body>
      </Modal>

      {/*alert for forgot password  */}
      <Modal
        className="reset-email-modal"
        size="dialog-centered"
        show={showResetConfirmation}
        onHide={handleCloseResetConfirmation}
        backdrop="static"
      >
        <Modal.Header closeButton className="border-btm-0 pe-4 pt-3 pb-0">
          {" "}
        </Modal.Header>
        <Modal.Body className="forgotEmailSentPopup">
          <div className="col-sm-12 mt-3 text-center">
            <img
              alt=""
              className="img-fluid mb-4 resetemail-img"
              src={`${process.env.PUBLIC_URL}/images/password-sent.svg`}
            />
          </div>
          <div className="col-sm-12 text-center mb-5">
            <h4 className="omnes-medium-font">
              {" "}
              {t("passwordResetEmailSent")}{" "}
            </h4>
            <p className="omnes-regular-font">
              {t("passwordResetEmailAddress")}
            </p>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={infoshow}
        onHide={handleMyInfoClose}
        size="lg modal-dialog-centered"
        className=" arabic-modal-left p-0"
        backdrop="static"
      // modal-content-radius arabic-modal-left
      >
        <Modal.Header closeButton className="border-btm-0 pe-4 pt-3 pb-0">
          <h5 className="omnes-medium-font pt-1 w-100">
            {" "}
            {isEditMode ? t("EditInfo") : t("Myinfo")}{" "}
          </h5>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <MyInfoModal
            setEditMode={handleEditModeChange}
            setShowchangePassword={setShowchangePassword}
            handleMyInfoClose={handleMyInfoClose}
            Email={Email}
            setEmail={setEmail}
          />
        </Modal.Body>
      </Modal>

      {/* Thank You Modal */}
      <Modal
        size="sm modal-dialog-centered feedback-modal"
        style={{ background: "#3b3a3a52" }}
        show={showThankYouModal}
        onHide={() => setShowThankYouModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="border-bottom-0 pb-0"></Modal.Header>
        <Modal.Body className="text-center p-0">
          <img alt=""
            className="m-auto"
            style={{ width: "130px", height: "130px" }}
            src={`${process.env.PUBLIC_URL}/images/sucess-gif.gif`}
          />
          <h5 style={{ fontWeight: "600" }}>
            {" "}
            {t("ThankYouForyourFeedback")}{" "}
          </h5>
        </Modal.Body>
        <Modal.Footer className="border-top-0 justify-content-center pb-3 pt-1">
          <Button
            variant="primary"
            onClick={() => setShowThankYouModal(false)}
            style={{ width: "50%" }}
          >
            {t("Back to Home")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Header;
